import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";


export let BASE_URL = "/specdev/rimguardraleigh/rgxral_api_handler.aspx";

BASE_URL =
	"https://www.rimguardrimrepair.com//specdev/rimguardraleigh/rgxral_api_handler.aspx";

export let BASE_HOST = "";


if (window.location.href.indexOf("localhost") > -1) {
	BASE_URL =
		"http://localhost:2344/specdev/rimguardraleigh/rgxral_api_handler.aspx";

	/// USED LOCALLY ONLY, WITH "SERVE" BUILD
	///  
	BASE_HOST = "http://localhost:2344";
}

if (window.location.href.indexOf("wilmingtonmedia") > -1) {
	BASE_URL =
		"http://www_rimguardrimrepair_com.wilmingtonmedia.com/specdev/rimguardraleigh/rgxral_api_handler.aspx";

	// BASE_HOST = "http://localhost:2344";
}



axios.defaults.baseURL = BASE_URL;
Vue.use(VueAxios, axios);
